import type { Dayjs } from 'dayjs'
import type { PropertyDefinitionModel } from '@/core/gql/gql-models-override.ts'
import type { PropertyValue } from '@/objects/gql/PropertyValue.ts'
import { TextPropertyInput } from '@/objects/property-forms/TextPropertyInput.tsx'
import { NumberPropertyInput } from '@/objects/property-forms/NumberPropertyInput.tsx'
import { DateInput } from '@/objects/property-forms/DateInput.tsx'
import { TogglePropertyInput } from '@/objects/property-forms/TogglePropertyInput.tsx'
import { Select1PropertyInput } from '@/objects/property-forms/select-1/Select1PropertyInput.tsx'
import { MultiSelectPropertyInput } from '@/objects/property-forms/multi-select/MultiSelectPropertyInput.tsx'

export interface GridCellProps {
  propDef: PropertyDefinitionModel
  value: PropertyValue | undefined
  onChange: (value: PropertyValue) => void
}

export function GridCell({ propDef, value, onChange }: GridCellProps) {
  switch (propDef.type) {
    case 'text':
      return (
        <TextPropertyInput value={(value as string | undefined) ?? ''} onValueChange={onChange} hidePlaceholder />
      )
    case 'number':
      return (
        <NumberPropertyInput
          value={(value as number | null | undefined) ?? null}
          onValueChange={onChange}
        />
      )
    case 'date':
      return (
        <DateInput
          value={(value as Dayjs | null | undefined) ?? null}
          onValueChange={onChange}
          readOnly={propDef.isMeta}
        />
      )
    case 'toggle':
      return (
        <TogglePropertyInput value={!!(value as boolean | undefined)} onValueChange={onChange} />
      )
    case 'select-1':
      return (
        <Select1PropertyInput
          propDef={propDef}
          value={(value as number | null | undefined) ?? null}
          onValueChange={onChange}
        />
      )
    case 'multi-select':
      return (
        <MultiSelectPropertyInput
          options={propDef.options ?? []}
          value={(value as number[] | undefined) ?? []}
          onValueChange={onChange}
          editable={{ propDef }}
        />
      )
    default:
      return null
  }
}
